// extracted by mini-css-extract-plugin
export var arrowButton = "switch-input-module--arrow-button--nR7K9";
export var arrowLeft = "switch-input-module--arrow-left--4GYaL";
export var arrowRight = "switch-input-module--arrow-right--4yhN2";
export var container = "switch-input-module--container--5smQa";
export var labelText = "switch-input-module--label-text--HqjZg";
export var switcher = "switch-input-module--switcher--OojyL";
export var text = "switch-input-module--text--e4K9m";